import { defineComponent as F, inject as L, computed as x, h as l } from "vue";
import { uploadInjectionKey as C } from "./ghl-ui.es1150.js";
import N from "./ghl-ui.es1156.js";
import T from "./ghl-ui.es1152.js";
import { throwError as U } from "./ghl-ui.es853.js";
import h from "./ghl-ui.es1023.js";
import b from "./ghl-ui.es858.js";
const K = F({
  name: "UploadFileList",
  setup(I, {
    slots: f
  }) {
    const t = L(C, null);
    t || U("upload-file-list", "`n-upload-file-list` must be placed inside `n-upload`.");
    const {
      abstractRef: p,
      mergedClsPrefixRef: o,
      listTypeRef: r,
      mergedFileListRef: n,
      fileListClassRef: m,
      fileListStyleRef: c,
      cssVarsRef: s,
      themeClassRef: a,
      maxReachedRef: v,
      showTriggerRef: g,
      imageGroupPropsRef: R
    } = t, i = x(() => r.value === "image-card"), u = () => n.value.map((e) => l(N, {
      clsPrefix: o.value,
      key: e.id,
      file: e,
      listType: r.value
    })), y = () => i.value ? l(h, Object.assign({}, R.value), {
      default: u
    }) : l(b, {
      group: !0
    }, {
      default: u
    });
    return () => {
      const {
        value: e
      } = o, {
        value: d
      } = p;
      return l("div", {
        class: [`${e}-upload-file-list`, i.value && `${e}-upload-file-list--grid`, d ? a == null ? void 0 : a.value : void 0, m.value],
        style: [d && s ? s.value : "", c.value]
      }, y(), g.value && !v.value && i.value && l(T, null, f));
    };
  }
});
export {
  K as default
};
